import { Injectable, NgZone } from "@angular/core";
import { DialogEntityManager, ReponseDialogEntityManager } from "../../global";
import { Observable } from "rxjs";
import { TinDialogEntityManagerComponent } from "./tin-dialog-entity-manager.component";
import { TinDialogAnimationService } from "../tin-dialog/tin-dialog-animation.service";
import { BusService } from "../../services/bus.service";


@Injectable()

export class TinDialogEntityManagerService {

  private dialogRef: any[]= [];
  constructor(
    public dialog: TinDialogAnimationService,
    private serviceBus: BusService,
    private zone: NgZone
    ) {
  }

  openCustomDialogEntityManager(config: DialogEntityManager, hasAnimation = true): Observable<any> {

      const width = config.width || '45%';
      const height  = config.height  || '95%';
      const maxWidth = config.maxWidth  || '80vw';
      const position  = config.position  || {top: '0px'};

      const options: any =  {
        position,
        width,
        height,
        maxWidth,
        backdropClass: 'customDialogEntityManager',
        animation: hasAnimation ?  {
          to: 'bottom',
          incomingOptions: {keyframeAnimationOptions: {duration: 100}},
          outgoingOptions: {keyframeAnimationOptions: {duration: 100}}
         } : undefined,
         data: {id: 0, width, height, ...config}
        };

      const dialogRef = this.dialog.open(TinDialogEntityManagerComponent, options);
      dialogRef.disableClose = config.disableClose ?? false;
      const id: any = dialogRef.id;
      this.dialogRef[id] = dialogRef;
      (<any>dialogRef.componentInstance).data.id = id;

   return new Observable((observer) => {
        dialogRef.afterClosed().subscribe((result: any) => {
          observer.next(result);
          observer.complete();
           if (this.dialogRef?.[id]) {
              delete this.dialogRef?.[id];
           }
          });
      });
  }

  okAndClose(item: any, dialogId: any): void {
    const dialogRef: any = this.dialogRef?.[dialogId];
    if (dialogRef) {
      dialogRef.close({response: ReponseDialogEntityManager.Ok, item});
    }
  }

  close(item: any, response: any, dialogId: any): void {
    const dialogRef: any = this.dialogRef?.[dialogId];
    if (dialogRef) {
      dialogRef.close({response: response, item});
    }
  }

  deleteAndClose(item: any, dialogId: any): void {
    const dialogRef: any = this.dialogRef?.[dialogId];
    if (dialogRef) {
      dialogRef.close({response: ReponseDialogEntityManager.Delete, item});
    }
  }

  
}

